import styled from 'styled-components';

export const ContainerInline = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  grid-gap: 5px;

  @media (max-width: 1199px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
